var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 44,
    viewBox: "0 0 53 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 25.1964C10.4055 25.1964 52.3387 7.23572 45.4318 1.56806C40.7153 -2.30226 16.788 14.595 14.0627 22.2788C13.0337 25.1801 12.6922 28.6473 13.3636 29.9813C15.1535 33.5374 20.6246 30.3868 21.4773 29.6471C24.9545 26.6304 21.0808 27.1048 20.3182 27.2988C13.75 28.9696 10.0166 35.0201 10.6591 40.0063C11.0455 43.0047 14.0627 43.6822 16.0682 42.3455C20.3552 39.4881 20.5535 36.0308 23.7955 32.6455C26.4255 29.8991 25.7954 38.8619 27.6591 39.3288C30.3636 40.0063 30.3636 30.6496 34.2273 30.3155C36.9629 30.0789 35.9457 36.9916 36.5455 37.6672C37.8395 39.1248 39.9031 33.7799 43.5 29.9813C44.6591 28.7572 46.1047 29.313 46.1047 30.9359C46.1047 37.6914 46.6975 38.8541 47.3636 40.0063C48.1364 41.343 49.6818 42.0113 52 42.0113",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.08e1d3b9b662492d70898e9318933f9a.svg";
export { ForwardRef as ReactComponent };